<template>
    <BehindTheScene :roomId="roomId" />
</template>

<script>
import BehindTheScene from "../components/conference/BehindTheScene.vue";

export default {
    name: "room-view",
    components: {
        BehindTheScene,
    },
    props: {
        roomId: {
            type: String,
            required: true,
        },
    },
};
</script>